import ErrorMessage from 'my-elements/ErrorMessage';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

const classes = {
  root: ({ spacing }) => ({ padding: spacing(2) }),
};

export default function StudentCoursePageActivityError({ drawerOpen, error, onToggleDrawer }) {
  const isRateLimitedError = error.status === 429;

  if (isRateLimitedError) {
    return (
      <div css={classes.root}>
        <Typography>
          You have made too many requests in a short span of time. If you are trying to view all course material,{' '}
          <Link component="button" onClick={drawerOpen ? undefined : onToggleDrawer} role="button">
            open the curriculum
          </Link>
          . Otherwise, you can request another activity in a minute.
        </Typography>
      </div>
    );
  }

  return (
    <div css={classes.root}>
      <ErrorMessage error={error} />
    </div>
  );
}
